module.exports = __webpack_public_path__ + "img/residencial_mx.f48971cd.png";